export default class MobileVideo {
    constructor(component) {
        const video = component.querySelector('video');
        const playButton = component.querySelector('button');
        const mobileWrapImg = component.querySelector('.mobile-wrap > div > img');
        this.initEvents(video, playButton, mobileWrapImg);
    }
    initEvents(video, playButton, mobileWrapImg) {
        // Force first-frame paint. Must use `loadeddata` (not `loadedmetadata`)
        // because Safari hasn't decoded any frame at the metadata stage, so the
        // seek silently no-ops and leaves a white canvas.
        video.addEventListener('loadeddata', () => {
            if (video.currentTime === 0) {
                try {
                    video.currentTime = 0.01;
                }
                catch (e) { /* noop */ }
            }
        }, { once: true });
        playButton.addEventListener('click', () => {
            video.muted = false;
            video.play();
            playButton.style.display = 'none';
        });
        video.addEventListener('click', () => {
            video.pause();
            playButton.style.display = 'block';
        });
        if (mobileWrapImg) {
            mobileWrapImg.addEventListener('click', () => {
                video.pause();
                playButton.style.display = 'block';
            });
        }
        video.addEventListener('ended', () => {
            playButton.style.display = 'block';
        });
    }
}
